<!-- =========================================================================================
    File Name: PurchaseProductsView.vue
    Description: Purchase Products view
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-3">
                <span class="text-primary text-sm"> Taxable </span>
                <p> {{ Taxable }}</p>
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3">
                <span class="text-primary text-sm"> Invoice Date </span>
                <p> {{ InvoiceDate }}</p>
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3">
                <span class="text-primary text-sm"> Invoice Number </span>
                <p> {{ InvoiceNumber }}</p>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full mb-3">
                <span class="text-primary text-sm"> Supplier Details </span>
                <p>
                    {{ PartyDetails }}
                </p>
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3">
                <span class="text-primary text-sm"> Description </span>
                <p> {{ Description }}</p>
            </div>
        </div>

        <vs-divider/>

        <vs-table :data="LocalPurchaseProducts">

            <template slot="thead">
                <vs-th> Product Code </vs-th>
                <vs-th> Product Name </vs-th>
                <vs-th> GST </vs-th>                
                <vs-th> Qty </vs-th>
                <vs-th> Price </vs-th>
                <vs-th> Sub Total </vs-th>
                <vs-th v-if="SgstFlag == 1"> SGST </vs-th>
                <vs-th v-if="SgstFlag == 1"> CGST </vs-th>
                <vs-th v-if="SgstFlag != 1"> IGST </vs-th>
                <vs-th v-if="CessFlag == 1"> CESS </vs-th>
                <vs-th> Amount </vs-th>
            </template>

            <vs-tr v-for="(LocalProduct, k) in LocalPurchaseProducts" :key="k">

                <vs-td>
                    {{ LocalProduct.CustomCode }}
                </vs-td>

                <vs-td>
                    {{ LocalProduct.ProductName }}
                </vs-td>

                <vs-td>
                    {{ LocalProduct.GstSlab }}
                </vs-td>

                <vs-td>
                    {{ LocalProduct.Qty }}
                </vs-td>                

                <vs-td>
                    {{ LocalProduct.Price }}
                </vs-td>

                <vs-td>
                    {{ LocalProduct.ProductSubTotal }}
                </vs-td>

                <vs-td v-if="SgstFlag == 1">
                    {{ LocalProduct.ProductSgst }}
                </vs-td>

                <vs-td v-if="SgstFlag == 1">
                    {{ LocalProduct.ProductCgst }}
                </vs-td>
                
                <vs-td v-if="SgstFlag != 1">
                    {{ LocalProduct.ProductIgst }}
                </vs-td>

                <vs-td v-if="CessFlag == 1">
                    {{ LocalProduct.ProductCess }}
                </vs-td>                

                <vs-td>
                    {{ LocalProduct.ProductTotal }}
                </vs-td>

            </vs-tr>                

        </vs-table>

        <vs-divider/>

        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                Invoice Sub Total
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ InvoiceSubTotal }}
            </div>
        </div>

        <div class="vx-row" v-if="SgstFlag == 1">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                SGST
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ Sgst }}
            </div>
        </div>

        <div class="vx-row" v-if="SgstFlag == 1">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                CGST
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ Cgst }}
            </div>
        </div>

        <div class="vx-row" v-if="SgstFlag != 1">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                IGST
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ Igst }}
            </div>
        </div>

        <div class="vx-row" v-if="CessFlag == 1">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                CESS
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ Cess }}
            </div>
        </div>
        
        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                Round Off
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ RoundOff }}
            </div>
        </div>
        
        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full mb-3 text-right">
                Invoice Total
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-3 text-left">
                {{ InvoiceTotal }}
            </div>
        </div>
        
        <vs-divider/>
        
    </div>
</template>

<script>

// import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select'

const dict = {
    custom: {
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
    },
    props: {
        viewProductsPrompt: {
            type: Boolean,
            required: true,
        },
        recordIndex: {
            type: Number,
            required: true,
        }
    },    
    data() {
        return {
            SgstFlag: this.$store.state.purchase.dataArray[this.recordIndex].IntraState,
            Taxable: this.$store.state.purchase.dataArray[this.recordIndex].Taxable,
            InvoiceDate: this.$store.state.purchase.dataArray[this.recordIndex].PurchaseInvoiceDateTxt,
            InvoiceNumber: this.$store.state.purchase.dataArray[this.recordIndex].PurchaseInvoiceNumber,
            Description: this.$store.state.purchase.dataArray[this.recordIndex].Description,
            PartyDetails: this.$store.state.purchase.dataArray[this.recordIndex].PartyDetails,
            Products: this.$store.state.purchase.dataArray[this.recordIndex].Products,
            InvoiceSubTotal: this.$store.state.purchase.dataArray[this.recordIndex].SubTotal,
            Sgst: this.$store.state.purchase.dataArray[this.recordIndex].sgst,
            Cgst: this.$store.state.purchase.dataArray[this.recordIndex].cgst,
            Igst: this.$store.state.purchase.dataArray[this.recordIndex].igst,
            Cess: this.$store.state.purchase.dataArray[this.recordIndex].Cess,
            CessFlag: this.$store.state.purchase.dataArray[this.recordIndex].CessFlag,
            RoundOff: this.$store.state.purchase.dataArray[this.recordIndex].RoundOff,
            InvoiceTotal: this.$store.state.purchase.dataArray[this.recordIndex].TotalAmount,
            LocalPurchaseProducts: this.$store.state.purchase.dataArray[this.recordIndex].Products,
        }
    },
    computed: {
        activePrompt: {
            get() {
                return this.addRecordPrompt;
            },
            set(value) {
                this.$emit('hideAddRecordPrompt', value);
            }
        },
        allPurchase(){
            return this.$store.getters['purchase/dataList'];
        },        
    },
    methods: {
        pdfgen: function () {
            var filename='test';
            var pdfType=1;
            var windowType=1;
            var content='My sample PDF';
            var styles='';
            var defaultStyle='';
            var docDefinition = {
            content: content,
            styles: styles,
            defaultStyle: defaultStyle
            };
            this.generatePDF(filename, pdfType, windowType, docDefinition);
        }

    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);            
        }
    },
    watch: {

    },
}
</script>
<style>
/*
.con-vs-popup .vs-popup {
    width: 950px;
}
*/
</style>